/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import moment from 'moment'
import StarRatings from 'react-star-ratings'
import ReactTable from 'react-table'
import createTable from 'react-table-hoc-fixed-columns'
// import "react-table/react-table.css";

import CSVExportModal from '../CSVExportModal'

const ReactTableFixedColumns = createTable(ReactTable)

class AdminCommunityPriorityTable extends Component {
  state = {
    showModal: false,
    dataLoader: false,
    data: [],
  }

  get headers() {
    const { t } = this.props
    return [
      { label: t('reports.adminCommunityPriority.community'), key: 'community' },
      {
        label: t('reports.adminCommunityPriority.accountManager'),
        key: 'accountmanager',
      },
      {
        label: t('reports.adminCommunityPriority.communityStage'),
        key: 'stage',
      },
      {
        label: t('reports.adminCommunityPriority.ourRating'),
        key: 'supportrating',
      },
      {
        label: t('reports.adminCommunityPriority.timeInNetwork'),
        key: 'timeinnetwork',
      },
      {
        label: t('reports.adminCommunityPriority.seasonStartDate'),
        key: 'seasonstartdate',
      },
      {
        label: t('reports.adminCommunityPriority.seasonEndDate'),
        key: 'seasonenddate',
      },
      {
        label: t('reports.adminCommunityPriority.daysSinceLastContacted'),
        key: 'lastcontacted',
      },
      {
        label: t('reports.adminCommunityPriority.daysSinceAttepted'),
        key: 'lastattempted',
      },
    ]
  }

  render() {
    const { showModal, data } = this.state

    return (
      <div>
        {this._renderTable()}
        {showModal && (
          <CSVExportModal
            headers={this.headers}
            data={data}
            showModal={showModal}
            toggleModal={this._toggleModal}
            reportType={this.props.t('reports.adminCommunityPriority.reportType')}
            filename={'community-priority-report.csv'}
          />
        )}
      </div>
    )
  }

  _toggleModal = data => {
    this.setState({
      showModal: !this.state.showModal,
      data: data ? data : [],
    })
  }

  _createData = () => {
    const { data } = this.props

    const tempData = []
    this.setState({ dataLoader: true })
    if (data.length > 0) {
      data.map(d => {
        const community = d.community
        const accountmanager = d.account_manager
        const stage = d.stage
        const supportrating = d.support_rating
        const timeinnetwork = d.time_in_network
        const seasonstartdate = d.season_start_date
        const seasonenddate = d.season_end_date
        const lastcontacted = d.last_contact_made
        const lastattempted = d.last_attempt_made

        tempData.push({
          community,
          accountmanager: accountmanager
            ? `${accountmanager.first_name} ${accountmanager.last_name}`
            : null,
          stage: stage ? stage.name : null,
          supportrating,
          timeinnetwork: moment(timeinnetwork).fromNow(),
          seasonstartdate: seasonstartdate
            ? moment(seasonstartdate).format('MM-DD-YYYY')
            : null,
          seasonenddate: seasonenddate
            ? moment(seasonenddate).format('MM-DD-YYYY')
            : null,
          lastcontacted: lastcontacted
            ? moment(lastcontacted.created_at).fromNow()
            : null,
          lastattempted: lastattempted
            ? moment(lastattempted.created_at).fromNow()
            : null,
        })
      })
    }

    this._toggleModal(tempData)
  }

  _renderTableCell = props => (
    <div
      className='number'
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {props.value ? props.value : '---'}
      </div>
    </div>
  )

  _renderDateCell = props => (
    <div
      className='number'
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {props.value ? moment(props.value).format('MM-DD-YYYY') : '---'}
      </div>
    </div>
  )

  _renderTimeFromCell = props => (
    <div
      className='number'
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {props.value ? moment(props.value).fromNow() : '---'}
      </div>
    </div>
  )

  _renderLastTimeSinceCell = props => (
    <div
      className='number'
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {props.value ? moment(props.value.created_at).fromNow() : '---'}
      </div>
    </div>
  )

  _renderStarColor = rating => {
    switch (rating) {
      case 0:
        return '#ed213a'
      case 1:
        return '#ed213a'
      case 2:
        return '#ed213a'
      case 3:
        return '#fddb10'
      case 4:
        return '#fddb10'
      case 5:
        return '#33d9b2'
      default:
        return '#ff6633'
    }
  }

  _renderRatingCell = props => (
    <div
      className='number'
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <StarRatings
        rating={props.value ? props.value : 0}
        starRatedColor={this._renderStarColor(props.value ? props.value : 0)}
        starHoverColor={'#64747f'}
        numberOfStars={5}
        name='support_rating'
        isSelectable={false}
        starDimension={'15px'}
      />
    </div>
  )

  _renderNameCell = props => (
    <div
      className='number'
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {props.value
          ? `${props.value.first_name} ${props.value.last_name}`
          : '---'}
      </div>
    </div>
  )

  _renderStageCell = props => (
    <div
      className='number'
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {props.value ? `${props.value.name}` : '---'}
      </div>
    </div>
  )
  _renderTable = () => {
    const { loader, data, fetchData, pages, t } = this.props

    const columns = [
      {
        Header: t('reports.adminCommunityPriority.communityName'),
        accessor: 'community',
        Cell: props => this._renderTableCell(props),
        fixed: true,
      },
      {
        Header: t('reports.adminCommunityPriority.accountManager'),
        accessor: 'account_manager',
        Cell: props => this._renderNameCell(props),
        sortable: false,
      },
      {
        Header: t('reports.adminCommunityPriority.communityStage'),
        accessor: 'stage',
        Cell: props => this._renderStageCell(props),
        sortable: false,
      },
      {
        Header: t('reports.adminCommunityPriority.ourRating'),
        accessor: 'support_rating',
        Cell: props => this._renderRatingCell(props),
      },
      {
        Header: t('reports.adminCommunityPriority.timeInNetwork'),
        accessor: 'time_in_network',
        Cell: props => this._renderTimeFromCell(props),
      },
      {
        Header: t('reports.adminCommunityPriority.seasonStartDate'),
        accessor: 'season_start_date',
        Cell: props => this._renderDateCell(props),
      },
      {
        Header: t('reports.adminCommunityPriority.seasonEndDate'),
        accessor: 'season_end_date',
        Cell: props => this._renderDateCell(props),
      },
      {
        Header: t('reports.adminCommunityPriority.daysSinceLastContact'),
        accessor: 'last_contact_made',
        Cell: props => this._renderLastTimeSinceCell(props),
        sortable: false,
      },
      {
        Header: t('reports.adminCommunityPriority.daysSinceAttempted'),
        accessor: 'last_attempt_made',
        Cell: props => this._renderLastTimeSinceCell(props),
        sortable: false,
      },
    ]

    return (
      <div className='container my-5 animated fadeIn'>
        <div className='row mb-5 d-flex align-items-center'>
          <div className='col-md-8'>
            <h2>{this.props.title}</h2>
          </div>
          <div className='col-md-4'>
            <button
              className='btn btn-sm btn-block'
              onClick={() => this.props.goBack()}
            >
              <i
                className='fa fa-arrow-left text-white mr-1'
                aria-hidden='true'
              />{' '}
              {t('reports.common.viewAnotherReport')}
            </button>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <ReactTableFixedColumns
              data={!loader ? data : []}
              columns={columns}
              pages={pages}
              pageSizeOptions={[5, 10, 20, 25, 50, 100]}
              defaultPageSize={25}
              loading={loader}
              loadingText={t('reports.common.loadingReport')}
              noDataText={loader ? '' : t('reports.common.noDataFound')}
              manual
              onFetchData={(state, instance) =>
                fetchData(state, instance, 'community_priority')
              }
            />
          </div>
        </div>
        <button onClick={this._createData} className='mt-3 btn btn-success'>
          {t('reports.common.exportAsCsv')}
        </button>
      </div>
    )
  }
}

export default withTranslation()(AdminCommunityPriorityTable)
